import { string, object, oneOf, oneOfType, array, bool, func } from 'prop-types'
import { renderIcon, kuiperClassNames } from '../utils'

import './styles.scss'

const renderText = (text, icon, type, iconOptions, navigateTo, isLinkable) => {
  if (!text) return null
  return (
    /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
    <div className={kuiperClassNames(type)}>
      <div
        className={kuiperClassNames('container', { 'is-link': isLinkable })}
        onClick={() => isLinkable && navigateTo()}
      >
        {icon ? renderIcon(icon, { ...iconOptions, ariaMode: 'hidden' }) : null}
        <span>{text}</span>
      </div>
    </div>
  )
}

const renderList = (list, navigateTo) => {
  if (!list.length) return null

  return list.map((item, i) => (
    <div key={i} className={kuiperClassNames('list description')}>
      <div
        className={kuiperClassNames('container is-link')}
        onClick={() => navigateTo(item.text)}
      >
        {item.icon
          ? renderIcon(item.icon, { ...item.iconOptions, ariaMode: 'hidden' })
          : null}
        <span>{item.text}</span>
      </div>
    </div>
  ))
}

const TitleAndDescription = ({
  className,
  description,
  descriptionIcon,
  descriptionIconOptions,
  descriptionStyle = 'dim',
  isLinkable,
  list = [],
  navigateTo,
  truncate = true,
  title,
  titleIcon,
  titleIconOptions,
}) => (
  <div
    className={kuiperClassNames(
      'title-and-description',
      descriptionStyle,
      className,
      { truncate }
    )}
  >
    {renderText(title, titleIcon, 'title', titleIconOptions, navigateTo)}
    {renderText(
      description,
      descriptionIcon,
      'description',
      descriptionIconOptions,
      navigateTo,
      isLinkable
    )}
    {renderList(list, navigateTo)}
  </div>
)

TitleAndDescription.propTypes = {
  className: string,
  description: oneOfType([object, string]),
  descriptionIcon: string,
  descriptionIconOptions: object,
  descriptionStyle: oneOf(['bright', 'dim']),
  isLinkable: bool,
  list: array,
  navigateTo: func,
  title: string,
  titleIcon: string,
  titleIconOptions: object,
  truncate: bool,
}

export default TitleAndDescription
